// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { acceptHandoff, addAttachment, addComment, assignToBucket, autoAssign, connectBudget, convertBucket, convertEntry, createApiKey, createBudget, createEntry, deleteApiKey, deleteAttachment, deleteComment, deleteEntry, finishGithubLogin, getAttachment, getAuthConfig, getBalances, getBudget, getEntry, getEntryHistory, getEntryNote, getHistory, getHistoryDetail, getMe, getMonth, inviteCollaborator, joinBudget, listApiKeys, listAttachments, listBuckets, listBudgets, listCollaborators, listComments, listDue, listEntries, listGithubRepos, listMembers, listScheduled, logout, lookupRate, moveMoney, nearbyPlaces, type Options, pollDeviceLogin, postScheduled, putBucket, putEntryNote, putMembers, putScheduled, redoChange, reorderBuckets, searchGithubUsers, searchPlaces, settleUp, startDeviceLogin, startGithubLogin, suggestEntry, suggestPayees, undoChange, updateEntry } from '../sdk.gen';
import type { AcceptHandoffData, AcceptHandoffError, AddAttachmentData, AddAttachmentError, AddAttachmentResponse, AddCommentData, AddCommentError, AddCommentResponse, AssignToBucketData, AssignToBucketError, AssignToBucketResponse, AutoAssignData, AutoAssignError, AutoAssignResponse, ConnectBudgetData, ConnectBudgetError, ConnectBudgetResponse, ConvertBucketData, ConvertBucketError, ConvertBucketResponse, ConvertEntryData, ConvertEntryError, ConvertEntryResponse, CreateApiKeyData, CreateApiKeyError, CreateApiKeyResponse, CreateBudgetData, CreateBudgetError, CreateBudgetResponse, CreateEntryData, CreateEntryError, CreateEntryResponse, DeleteApiKeyData, DeleteApiKeyError, DeleteApiKeyResponse, DeleteAttachmentData, DeleteAttachmentError, DeleteAttachmentResponse, DeleteCommentData, DeleteCommentError, DeleteCommentResponse, DeleteEntryData, DeleteEntryError, DeleteEntryResponse, FinishGithubLoginData, FinishGithubLoginError, GetAttachmentData, GetAttachmentError, GetAuthConfigData, GetAuthConfigResponse, GetBalancesData, GetBalancesError, GetBalancesResponse, GetBudgetData, GetBudgetError, GetBudgetResponse, GetEntryData, GetEntryError, GetEntryHistoryData, GetEntryHistoryError, GetEntryHistoryResponse, GetEntryNoteData, GetEntryNoteError, GetEntryNoteResponse, GetEntryResponse, GetHistoryData, GetHistoryDetailData, GetHistoryDetailError, GetHistoryDetailResponse, GetHistoryError, GetHistoryResponse, GetMeData, GetMeError, GetMeResponse, GetMonthData, GetMonthError, GetMonthResponse, InviteCollaboratorData, InviteCollaboratorError, InviteCollaboratorResponse, JoinBudgetData, JoinBudgetError, JoinBudgetResponse, ListApiKeysData, ListApiKeysError, ListApiKeysResponse, ListAttachmentsData, ListAttachmentsError, ListAttachmentsResponse, ListBucketsData, ListBucketsError, ListBucketsResponse, ListBudgetsData, ListBudgetsError, ListBudgetsResponse, ListCollaboratorsData, ListCollaboratorsError, ListCollaboratorsResponse, ListCommentsData, ListCommentsError, ListCommentsResponse, ListDueData, ListDueError, ListDueResponse, ListEntriesData, ListEntriesError, ListEntriesResponse, ListGithubReposData, ListGithubReposError, ListGithubReposResponse, ListMembersData, ListMembersError, ListMembersResponse, ListScheduledData, ListScheduledError, ListScheduledResponse, LogoutData, LogoutResponse, LookupRateData, LookupRateError, LookupRateResponse, MoveMoneyData, MoveMoneyError, MoveMoneyResponse, NearbyPlacesData, NearbyPlacesError, NearbyPlacesResponse, PollDeviceLoginData, PollDeviceLoginError, PollDeviceLoginResponse, PostScheduledData, PostScheduledError, PostScheduledResponse, PutBucketData, PutBucketError, PutBucketResponse, PutEntryNoteData, PutEntryNoteError, PutEntryNoteResponse, PutMembersData, PutMembersError, PutMembersResponse, PutScheduledData, PutScheduledError, PutScheduledResponse, RedoChangeData, RedoChangeError, RedoChangeResponse, ReorderBucketsData, ReorderBucketsError, ReorderBucketsResponse, SearchGithubUsersData, SearchGithubUsersError, SearchGithubUsersResponse, SearchPlacesData, SearchPlacesError, SearchPlacesResponse, SettleUpData, SettleUpError, SettleUpResponse, StartDeviceLoginData, StartDeviceLoginResponse, StartGithubLoginData, StartGithubLoginError, SuggestEntryData, SuggestEntryError, SuggestEntryResponse, SuggestPayeesData, SuggestPayeesError, SuggestPayeesResponse, UndoChangeData, UndoChangeError, UndoChangeResponse, UpdateEntryData, UpdateEntryError, UpdateEntryResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getAuthConfigQueryKey = (options?: Options<GetAuthConfigData>) => createQueryKey('getAuthConfig', options);

/**
 * Get Auth Config
 *
 * Where this deployment's sign-in starts.
 *
 * Computed server-side because only the server knows whether it is production or a preview;
 * the browser guessing its own prod origin from the hostname would be one more thing to
 * keep correct.
 */
export const getAuthConfigOptions = (options?: Options<GetAuthConfigData>) => queryOptions<GetAuthConfigResponse, DefaultError, GetAuthConfigResponse, ReturnType<typeof getAuthConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuthConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuthConfigQueryKey(options)
});

export const startGithubLoginQueryKey = (options?: Options<StartGithubLoginData>) => createQueryKey('startGithubLogin', options);

/**
 * Begin browser sign-in
 */
export const startGithubLoginOptions = (options?: Options<StartGithubLoginData>) => queryOptions<unknown, StartGithubLoginError, unknown, ReturnType<typeof startGithubLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await startGithubLogin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: startGithubLoginQueryKey(options)
});

export const finishGithubLoginQueryKey = (options: Options<FinishGithubLoginData>) => createQueryKey('finishGithubLogin', options);

/**
 * OAuth callback
 */
export const finishGithubLoginOptions = (options: Options<FinishGithubLoginData>) => queryOptions<unknown, FinishGithubLoginError, unknown, ReturnType<typeof finishGithubLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await finishGithubLogin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: finishGithubLoginQueryKey(options)
});

export const acceptHandoffQueryKey = (options: Options<AcceptHandoffData>) => createQueryKey('acceptHandoff', options);

/**
 * Accept a preview sign-in ticket
 *
 * Complete a sign-in that production started on this preview's behalf.
 *
 * The ticket is checked against *this* deployment's own hostname, so a ticket minted for
 * `pr-42` is useless at `pr-43` even though both trust the same signing key.
 */
export const acceptHandoffOptions = (options: Options<AcceptHandoffData>) => queryOptions<unknown, AcceptHandoffError, unknown, ReturnType<typeof acceptHandoffQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await acceptHandoff({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: acceptHandoffQueryKey(options)
});

/**
 * Sign out
 */
export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Begin CLI sign-in
 */
export const startDeviceLoginMutation = (options?: Partial<Options<StartDeviceLoginData>>): UseMutationOptions<StartDeviceLoginResponse, DefaultError, Options<StartDeviceLoginData>> => {
    const mutationOptions: UseMutationOptions<StartDeviceLoginResponse, DefaultError, Options<StartDeviceLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startDeviceLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Exchange an approved device code for an API key
 *
 * Returns `pending` until the user approves in their browser.
 *
 * On approval this mints a *money* API key rather than handing the CLI the GitHub token,
 * so revoking CLI access never means revoking GitHub access.
 */
export const pollDeviceLoginMutation = (options?: Partial<Options<PollDeviceLoginData>>): UseMutationOptions<PollDeviceLoginResponse, PollDeviceLoginError, Options<PollDeviceLoginData>> => {
    const mutationOptions: UseMutationOptions<PollDeviceLoginResponse, PollDeviceLoginError, Options<PollDeviceLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pollDeviceLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBudgetsQueryKey = (options?: Options<ListBudgetsData>) => createQueryKey('listBudgets', options);

/**
 * Budgets you can see
 *
 * Every linked budget whose repo GitHub says the caller can read.
 *
 * Budgets they cannot read are omitted, not reported as forbidden.
 */
export const listBudgetsOptions = (options?: Options<ListBudgetsData>) => queryOptions<ListBudgetsResponse, ListBudgetsError, ListBudgetsResponse, ReturnType<typeof listBudgetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBudgets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBudgetsQueryKey(options)
});

/**
 * Connect a GitHub repo as a budget
 */
export const connectBudgetMutation = (options?: Partial<Options<ConnectBudgetData>>): UseMutationOptions<ConnectBudgetResponse, ConnectBudgetError, Options<ConnectBudgetData>> => {
    const mutationOptions: UseMutationOptions<ConnectBudgetResponse, ConnectBudgetError, Options<ConnectBudgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectBudget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start a new budget in a new or empty repo
 *
 * Create the repo, write the first `budget.yaml`, and link it — in one call.
 *
 * Connecting a repo assumed one already held a budget, which left someone with no budget
 * at all nowhere to start: the only route in was hand-writing YAML on github.com. This is
 * that missing step, and it is deliberately one call because every intermediate state
 * (repo but no budget, budget but no buckets) is one the person would have to be told
 * about for no reason.
 */
export const createBudgetMutation = (options?: Partial<Options<CreateBudgetData>>): UseMutationOptions<CreateBudgetResponse, CreateBudgetError, Options<CreateBudgetData>> => {
    const mutationOptions: UseMutationOptions<CreateBudgetResponse, CreateBudgetError, Options<CreateBudgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBudget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBudgetQueryKey = (options: Options<GetBudgetData>) => createQueryKey('getBudget', options);

/**
 * One budget
 */
export const getBudgetOptions = (options: Options<GetBudgetData>) => queryOptions<GetBudgetResponse, GetBudgetError, GetBudgetResponse, ReturnType<typeof getBudgetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBudget({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBudgetQueryKey(options)
});

export const listMembersQueryKey = (options: Options<ListMembersData>) => createQueryKey('listMembers', options);

/**
 * Who is in this budget
 */
export const listMembersOptions = (options: Options<ListMembersData>) => queryOptions<ListMembersResponse, ListMembersError, ListMembersResponse, ReturnType<typeof listMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMembersQueryKey(options)
});

/**
 * Replace the member list
 *
 * Replaces the list wholesale, so removals are expressible and not just additions.
 *
 * Membership decides who can be assigned a share, not who can reach the budget — that is
 * GitHub repo access. Someone listed here without repo access simply never signs in.
 */
export const putMembersMutation = (options?: Partial<Options<PutMembersData>>): UseMutationOptions<PutMembersResponse, PutMembersError, Options<PutMembersData>> => {
    const mutationOptions: UseMutationOptions<PutMembersResponse, PutMembersError, Options<PutMembersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putMembers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add yourself to a budget you can push to
 *
 * Join a budget whose repo you already have push access to.
 *
 * Without this, being handed a budget repo by someone who forgot to add you to
 * `budget.yaml` made every screen fail with a 403 telling you to go and edit YAML — while
 * the app's own member editor sat behind the same 403. Push access is the authority the
 * rest of the app already trusts to decide who may change this data; refusing to let a
 * person with that access name themselves was the app contradicting itself.
 *
 * It only ever adds you. Editing anyone else stays with `putMembers`, where removing
 * someone is checked against the entries that reference them.
 */
export const joinBudgetMutation = (options?: Partial<Options<JoinBudgetData>>): UseMutationOptions<JoinBudgetResponse, JoinBudgetError, Options<JoinBudgetData>> => {
    const mutationOptions: UseMutationOptions<JoinBudgetResponse, JoinBudgetError, Options<JoinBudgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await joinBudget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMonthQueryKey = (options: Options<GetMonthData>) => createQueryKey('getMonth', options);

/**
 * Envelope view for a month
 *
 * Buckets are shared, so this returns every funder's standing in each of them.
 *
 * `person` still decides whose ready-to-assign is reported, because income arrives to a
 * person and so does the money that has not been given a job yet.
 */
export const getMonthOptions = (options: Options<GetMonthData>) => queryOptions<GetMonthResponse, GetMonthError, GetMonthResponse, ReturnType<typeof getMonthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMonth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMonthQueryKey(options)
});

/**
 * Assign money to a bucket
 */
export const assignToBucketMutation = (options?: Partial<Options<AssignToBucketData>>): UseMutationOptions<AssignToBucketResponse, AssignToBucketError, Options<AssignToBucketData>> => {
    const mutationOptions: UseMutationOptions<AssignToBucketResponse, AssignToBucketError, Options<AssignToBucketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignToBucket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Fund several buckets at once
 *
 * Assign to many buckets in one action, which is the payday case.
 *
 * Funding envelopes one at a time is the single most repeated chore in envelope budgeting.
 * Three strategies cover it: top every bucket up to its target, or repeat what was assigned
 * or spent last month.
 *
 * A bucket's target belongs to the household, so filling it fills it **in the bucket's split
 * ratio** — four people at 25% each put in a quarter of the shortfall. Funding is otherwise
 * nobody's business but their own, which is why the other two strategies stay personal: what
 * *you* assigned or spent last month says nothing about what anyone else did.
 *
 * This deliberately does not stop when the money runs out. Any funder's ready-to-assign is
 * allowed to go negative, and the month view says so — refusing would leave the plan
 * half-applied and harder to reason about than an overcommitment you can see.
 */
export const autoAssignMutation = (options?: Partial<Options<AutoAssignData>>): UseMutationOptions<AutoAssignResponse, AutoAssignError, Options<AutoAssignData>> => {
    const mutationOptions: UseMutationOptions<AutoAssignResponse, AutoAssignError, Options<AutoAssignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await autoAssign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move money from one bucket to another
 *
 * Take from one envelope and give to another, in one action.
 *
 * Covering an overspend by editing two assignment figures means doing the arithmetic
 * yourself and leaving the budget briefly wrong between the two saves. This does both sides
 * together and refuses to move more than the source actually holds.
 */
export const moveMoneyMutation = (options?: Partial<Options<MoveMoneyData>>): UseMutationOptions<MoveMoneyResponse, MoveMoneyError, Options<MoveMoneyData>> => {
    const mutationOptions: UseMutationOptions<MoveMoneyResponse, MoveMoneyError, Options<MoveMoneyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await moveMoney({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move buckets into a new order, in one commit
 *
 * One drag, one commit.
 *
 * A drag can shift every bucket it passes, and they all live in one file — so doing it a
 * bucket at a time meant N requests, each a full fetch, commit and push, all rewriting the
 * same file. Beyond being slow, it made the reorder non-atomic: a failure partway left a
 * half-applied order, and the intermediate states were briefly visible to anyone else.
 *
 * It cannot create, delete, rename or retarget a bucket. Position is the only thing a drag
 * means, and a wholesale replace would let a client holding a stale list undo somebody
 * else's rename in passing.
 */
export const reorderBucketsMutation = (options?: Partial<Options<ReorderBucketsData>>): UseMutationOptions<ReorderBucketsResponse, ReorderBucketsError, Options<ReorderBucketsData>> => {
    const mutationOptions: UseMutationOptions<ReorderBucketsResponse, ReorderBucketsError, Options<ReorderBucketsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reorderBuckets({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create or update one of your buckets
 */
export const putBucketMutation = (options?: Partial<Options<PutBucketData>>): UseMutationOptions<PutBucketResponse, PutBucketError, Options<PutBucketData>> => {
    const mutationOptions: UseMutationOptions<PutBucketResponse, PutBucketError, Options<PutBucketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putBucket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBucketsQueryKey = (options: Options<ListBucketsData>) => createQueryKey('listBuckets', options);

/**
 * Every bucket in the budget
 *
 * Buckets are shared, so this no longer takes a person.
 *
 * Each one carries the split that decides who bears its spending; how much any individual
 * has put in lives in the month view, not here.
 */
export const listBucketsOptions = (options: Options<ListBucketsData>) => queryOptions<ListBucketsResponse, ListBucketsError, ListBucketsResponse, ReturnType<typeof listBucketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBuckets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBucketsQueryKey(options)
});

export const getBalancesQueryKey = (options: Options<GetBalancesData>) => createQueryKey('getBalances', options);

/**
 * Who owes whom
 */
export const getBalancesOptions = (options: Options<GetBalancesData>) => queryOptions<GetBalancesResponse, GetBalancesError, GetBalancesResponse, ReturnType<typeof getBalancesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBalances({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBalancesQueryKey(options)
});

/**
 * Record a payment between two people
 *
 * A settlement moves both net positions and touches no envelope.
 *
 * `payer` defaults to the calling user but may name the other party. The person who is
 * *owed* is usually the one holding the phone when the money arrives, and if their partner
 * does not use the app nobody could otherwise record it. The caller must be one of the two
 * parties, so this records payments you were involved in, not other people's.
 */
export const settleUpMutation = (options?: Partial<Options<SettleUpData>>): UseMutationOptions<SettleUpResponse, SettleUpError, Options<SettleUpData>> => {
    const mutationOptions: UseMutationOptions<SettleUpResponse, SettleUpError, Options<SettleUpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await settleUp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const lookupRateQueryKey = (options: Options<LookupRateData>) => createQueryKey('lookupRate', options);

/**
 * What one unit of a currency is worth in the budget's, on a day
 *
 * Read-only: answers from the table, else asks the provider without committing. The
 * rate is committed only by the conversion that uses it, so the form can show what a
 * conversion would do without leaving a row nothing depends on.
 */
export const lookupRateOptions = (options: Options<LookupRateData>) => queryOptions<LookupRateResponse, LookupRateError, LookupRateResponse, ReturnType<typeof lookupRateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await lookupRate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: lookupRateQueryKey(options)
});

/**
 * Convert every unconverted entry in one currency with a share in a bucket
 *
 * One rate, one commit. An entry whose shares span two buckets converts whole, because an
 * entry has one `fx`; those are listed so the person knows the other bucket moved too.
 * See specs/currency.md, CUR-8.
 */
export const convertBucketMutation = (options?: Partial<Options<ConvertBucketData>>): UseMutationOptions<ConvertBucketResponse, ConvertBucketError, Options<ConvertBucketData>> => {
    const mutationOptions: UseMutationOptions<ConvertBucketResponse, ConvertBucketError, Options<ConvertBucketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await convertBucket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEntriesQueryKey = (options: Options<ListEntriesData>) => createQueryKey('listEntries', options);

/**
 * List entries
 */
export const listEntriesOptions = (options: Options<ListEntriesData>) => queryOptions<ListEntriesResponse, ListEntriesError, ListEntriesResponse, ReturnType<typeof listEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEntriesQueryKey(options)
});

/**
 * Record an entry
 */
export const createEntryMutation = (options?: Partial<Options<CreateEntryData>>): UseMutationOptions<CreateEntryResponse, CreateEntryError, Options<CreateEntryData>> => {
    const mutationOptions: UseMutationOptions<CreateEntryResponse, CreateEntryError, Options<CreateEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const suggestPayeesQueryKey = (options: Options<SuggestPayeesData>) => createQueryKey('suggestPayees', options);

/**
 * Payees you have used before
 *
 * Payees from this budget's own history, with the amount and bucket usually used.
 *
 * Typing a shop's name in full every time is the slowest part of logging an expense, and
 * the answer is already in the ledger. Ranked by how recently *and* how often a payee was
 * used: a shop visited weekly should beat one visited once a year, but a one-off from
 * yesterday should still be reachable.
 */
export const suggestPayeesOptions = (options: Options<SuggestPayeesData>) => queryOptions<SuggestPayeesResponse, SuggestPayeesError, SuggestPayeesResponse, ReturnType<typeof suggestPayeesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suggestPayees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suggestPayeesQueryKey(options)
});

/**
 * Delete an entry
 */
export const deleteEntryMutation = (options?: Partial<Options<DeleteEntryData>>): UseMutationOptions<DeleteEntryResponse, DeleteEntryError, Options<DeleteEntryData>> => {
    const mutationOptions: UseMutationOptions<DeleteEntryResponse, DeleteEntryError, Options<DeleteEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEntryQueryKey = (options: Options<GetEntryData>) => createQueryKey('getEntry', options);

/**
 * Get one entry
 */
export const getEntryOptions = (options: Options<GetEntryData>) => queryOptions<GetEntryResponse, GetEntryError, GetEntryResponse, ReturnType<typeof getEntryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEntry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEntryQueryKey(options)
});

/**
 * Edit an entry
 */
export const updateEntryMutation = (options?: Partial<Options<UpdateEntryData>>): UseMutationOptions<UpdateEntryResponse, UpdateEntryError, Options<UpdateEntryData>> => {
    const mutationOptions: UseMutationOptions<UpdateEntryResponse, UpdateEntryError, Options<UpdateEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEntryHistoryQueryKey = (options: Options<GetEntryHistoryData>) => createQueryKey('getEntryHistory', options);

/**
 * Commits that touched this entry
 */
export const getEntryHistoryOptions = (options: Options<GetEntryHistoryData>) => queryOptions<GetEntryHistoryResponse, GetEntryHistoryError, GetEntryHistoryResponse, ReturnType<typeof getEntryHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEntryHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEntryHistoryQueryKey(options)
});

export const getEntryNoteQueryKey = (options: Options<GetEntryNoteData>) => createQueryKey('getEntryNote', options);

/**
 * Long-form note for an entry
 */
export const getEntryNoteOptions = (options: Options<GetEntryNoteData>) => queryOptions<GetEntryNoteResponse, GetEntryNoteError, GetEntryNoteResponse, ReturnType<typeof getEntryNoteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEntryNote({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEntryNoteQueryKey(options)
});

/**
 * Write the long-form note for an entry
 *
 * Markdown in `notes/<entry-id>.md`, so a paragraph of context diffs line by line.
 */
export const putEntryNoteMutation = (options?: Partial<Options<PutEntryNoteData>>): UseMutationOptions<PutEntryNoteResponse, PutEntryNoteError, Options<PutEntryNoteData>> => {
    const mutationOptions: UseMutationOptions<PutEntryNoteResponse, PutEntryNoteError, Options<PutEntryNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putEntryNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Convert an unconverted entry into the budget currency
 *
 * Adds `fx` at the rate for the day of conversion — that is what "convert it now" means
 * — or another day's, or one typed. See specs/currency.md, CUR-7.
 */
export const convertEntryMutation = (options?: Partial<Options<ConvertEntryData>>): UseMutationOptions<ConvertEntryResponse, ConvertEntryError, Options<ConvertEntryData>> => {
    const mutationOptions: UseMutationOptions<ConvertEntryResponse, ConvertEntryError, Options<ConvertEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await convertEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCommentsQueryKey = (options: Options<ListCommentsData>) => createQueryKey('listComments', options);

/**
 * The conversation under an entry
 */
export const listCommentsOptions = (options: Options<ListCommentsData>) => queryOptions<ListCommentsResponse, ListCommentsError, ListCommentsResponse, ReturnType<typeof listCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCommentsQueryKey(options)
});

/**
 * Say something under an entry
 *
 * Appends and returns the whole thread, so a client can render the reply in place
 * without a second round trip — the thread is short by nature.
 */
export const addCommentMutation = (options?: Partial<Options<AddCommentData>>): UseMutationOptions<AddCommentResponse, AddCommentError, Options<AddCommentData>> => {
    const mutationOptions: UseMutationOptions<AddCommentResponse, AddCommentError, Options<AddCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Take back something you said
 *
 * Only the author. A comment is attributed speech, and removing someone else's words
 * from a shared record is not an edit anybody should be able to make silently.
 */
export const deleteCommentMutation = (options?: Partial<Options<DeleteCommentData>>): UseMutationOptions<DeleteCommentResponse, DeleteCommentError, Options<DeleteCommentData>> => {
    const mutationOptions: UseMutationOptions<DeleteCommentResponse, DeleteCommentError, Options<DeleteCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAttachmentsQueryKey = (options: Options<ListAttachmentsData>) => createQueryKey('listAttachments', options);

/**
 * Files kept beside an entry
 */
export const listAttachmentsOptions = (options: Options<ListAttachmentsData>) => queryOptions<ListAttachmentsResponse, ListAttachmentsError, ListAttachmentsResponse, ReturnType<typeof listAttachmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAttachments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAttachmentsQueryKey(options)
});

/**
 * Attach a receipt photo or PDF
 *
 * The body is the file itself.
 *
 * Raw bytes rather than multipart: there is exactly one file per request, so a multipart
 * envelope would add a parser dependency and a field name for nothing. The type comes from
 * the Content-Type header when it names one we accept, else from `media_type` — a
 * generated client sends the schema's octet-stream header and cannot say more.
 */
export const addAttachmentMutation = (options?: Partial<Options<AddAttachmentData>>): UseMutationOptions<AddAttachmentResponse, AddAttachmentError, Options<AddAttachmentData>> => {
    const mutationOptions: UseMutationOptions<AddAttachmentResponse, AddAttachmentError, Options<AddAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a file from an entry
 */
export const deleteAttachmentMutation = (options?: Partial<Options<DeleteAttachmentData>>): UseMutationOptions<DeleteAttachmentResponse, DeleteAttachmentError, Options<DeleteAttachmentData>> => {
    const mutationOptions: UseMutationOptions<DeleteAttachmentResponse, DeleteAttachmentError, Options<DeleteAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAttachmentQueryKey = (options: Options<GetAttachmentData>) => createQueryKey('getAttachment', options);

/**
 * The file itself
 */
export const getAttachmentOptions = (options: Options<GetAttachmentData>) => queryOptions<unknown, GetAttachmentError, unknown, ReturnType<typeof getAttachmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAttachment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAttachmentQueryKey(options)
});

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

/**
 * Who am I
 */
export const getMeOptions = (options?: Options<GetMeData>) => queryOptions<GetMeResponse, GetMeError, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});

export const listApiKeysQueryKey = (options?: Options<ListApiKeysData>) => createQueryKey('listApiKeys', options);

/**
 * Your API keys
 */
export const listApiKeysOptions = (options?: Options<ListApiKeysData>) => queryOptions<ListApiKeysResponse, ListApiKeysError, ListApiKeysResponse, ReturnType<typeof listApiKeysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listApiKeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listApiKeysQueryKey(options)
});

/**
 * Create an API key
 *
 * The token is returned once here and never again; only its hash is stored.
 */
export const createApiKeyMutation = (options?: Partial<Options<CreateApiKeyData>>): UseMutationOptions<CreateApiKeyResponse, CreateApiKeyError, Options<CreateApiKeyData>> => {
    const mutationOptions: UseMutationOptions<CreateApiKeyResponse, CreateApiKeyError, Options<CreateApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke an API key
 */
export const deleteApiKeyMutation = (options?: Partial<Options<DeleteApiKeyData>>): UseMutationOptions<DeleteApiKeyResponse, DeleteApiKeyError, Options<DeleteApiKeyData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiKeyResponse, DeleteApiKeyError, Options<DeleteApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGithubReposQueryKey = (options?: Options<ListGithubReposData>) => createQueryKey('listGithubRepos', options);

/**
 * Repos you could connect as a budget
 *
 * Lists the caller's repos, flagging which already look like a budget.
 *
 * "Looks like a budget" means it has a `budget.yaml`. That is checked for the most recently
 * pushed repos only — one API call each — and everything else is still listed, just without
 * the flag. Guessing wrong is cheap: connecting a repo without one fails with a clear error.
 */
export const listGithubReposOptions = (options?: Options<ListGithubReposData>) => queryOptions<ListGithubReposResponse, ListGithubReposError, ListGithubReposResponse, ReturnType<typeof listGithubReposQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listGithubRepos({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listGithubReposQueryKey(options)
});

export const searchGithubUsersQueryKey = (options: Options<SearchGithubUsersData>) => createQueryKey('searchGithubUsers', options);

/**
 * Find a GitHub user to invite
 */
export const searchGithubUsersOptions = (options: Options<SearchGithubUsersData>) => queryOptions<SearchGithubUsersResponse, SearchGithubUsersError, SearchGithubUsersResponse, ReturnType<typeof searchGithubUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchGithubUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchGithubUsersQueryKey(options)
});

export const listCollaboratorsQueryKey = (options: Options<ListCollaboratorsData>) => createQueryKey('listCollaborators', options);

/**
 * Who has access to the data repo
 *
 * Repo access is the real permission model, so this shows it directly.
 *
 * Pending invitations are included: without them someone just invited does not appear at
 * all, and it looks as though the invitation failed.
 */
export const listCollaboratorsOptions = (options: Options<ListCollaboratorsData>) => queryOptions<ListCollaboratorsResponse, ListCollaboratorsError, ListCollaboratorsResponse, ReturnType<typeof listCollaboratorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCollaborators({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCollaboratorsQueryKey(options)
});

/**
 * Invite someone to the budget's data repo
 *
 * Sends a real GitHub invitation, and adds them to the budget's member list.
 *
 * Both halves are needed and they are not the same thing: the invitation is what lets them
 * sign in at all, and membership is what lets them hold a share of an entry. Doing only the
 * first was the old behaviour, and it left people able to log in to a budget that could not
 * reference them.
 */
export const inviteCollaboratorMutation = (options?: Partial<Options<InviteCollaboratorData>>): UseMutationOptions<InviteCollaboratorResponse, InviteCollaboratorError, Options<InviteCollaboratorData>> => {
    const mutationOptions: UseMutationOptions<InviteCollaboratorResponse, InviteCollaboratorError, Options<InviteCollaboratorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await inviteCollaborator({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listScheduledQueryKey = (options: Options<ListScheduledData>) => createQueryKey('listScheduled', options);

/**
 * Recurring entries
 */
export const listScheduledOptions = (options: Options<ListScheduledData>) => queryOptions<ListScheduledResponse, ListScheduledError, ListScheduledResponse, ReturnType<typeof listScheduledQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listScheduled({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listScheduledQueryKey(options)
});

/**
 * Replace the recurring entries
 */
export const putScheduledMutation = (options?: Partial<Options<PutScheduledData>>): UseMutationOptions<PutScheduledResponse, PutScheduledError, Options<PutScheduledData>> => {
    const mutationOptions: UseMutationOptions<PutScheduledResponse, PutScheduledError, Options<PutScheduledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putScheduled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDueQueryKey = (options: Options<ListDueData>) => createQueryKey('listDue', options);

/**
 * Recurring entries that are due
 *
 * What each recurrence owes the ledger, up to `through` (default: two weeks out).
 *
 * Dates already posted are excluded, so opening this twice never offers the same charge
 * twice. A paused recurrence is skipped entirely.
 */
export const listDueOptions = (options: Options<ListDueData>) => queryOptions<ListDueResponse, ListDueError, ListDueResponse, ReturnType<typeof listDueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDueQueryKey(options)
});

/**
 * Turn a due recurrence into a real entry
 *
 * Creates the entry and records that this date was posted, in one commit.
 *
 * One commit matters: if the entry landed and the marker did not, the same charge would be
 * offered again and posted twice.
 */
export const postScheduledMutation = (options?: Partial<Options<PostScheduledData>>): UseMutationOptions<PostScheduledResponse, PostScheduledError, Options<PostScheduledData>> => {
    const mutationOptions: UseMutationOptions<PostScheduledResponse, PostScheduledError, Options<PostScheduledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postScheduled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHistoryQueryKey = (options: Options<GetHistoryData>) => createQueryKey('getHistory', options);

/**
 * Everything that has changed, newest first
 *
 * One feed for every change, whichever file it touched.
 *
 * Assignments show up next to entries because they are the same kind of event to the person
 * reading — money moved — even though one lives in a ledger file and the other in a map.
 */
export const getHistoryOptions = (options: Options<GetHistoryData>) => queryOptions<GetHistoryResponse, GetHistoryError, GetHistoryResponse, ReturnType<typeof getHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHistoryQueryKey(options)
});

export const getHistoryDetailQueryKey = (options: Options<GetHistoryDetailData>) => createQueryKey('getHistoryDetail', options);

/**
 * What one change actually did
 *
 * The diff, so "what did this change" has an answer that is not a guess.
 *
 * A subject line names what someone meant to do. The patch is what actually happened, and
 * for a data model stored as YAML it reads well enough to be the answer rather than a
 * debugging aid — an assignment is one number changing on one line.
 *
 * Whether it can still be undone is answered here rather than left to the client, because
 * it needs the whole log: a change that something later reverted is no longer applied, and
 * offering to undo it again would revert the revert.
 */
export const getHistoryDetailOptions = (options: Options<GetHistoryDetailData>) => queryOptions<GetHistoryDetailResponse, GetHistoryDetailError, GetHistoryDetailResponse, ReturnType<typeof getHistoryDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHistoryDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHistoryDetailQueryKey(options)
});

/**
 * Undo a change you made
 *
 * Revert a change, defaulting to your most recent un-reverted one.
 *
 * Scoped to your own changes: in a shared budget, silently reversing your partner's work
 * from your phone is the failure worth designing against. Naming a sha reverts anyone's,
 * which makes doing so deliberate.
 */
export const undoChangeMutation = (options?: Partial<Options<UndoChangeData>>): UseMutationOptions<UndoChangeResponse, UndoChangeError, Options<UndoChangeData>> => {
    const mutationOptions: UseMutationOptions<UndoChangeResponse, UndoChangeError, Options<UndoChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await undoChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Re-apply something you undid
 *
 * Re-apply the change your last undo reversed, by reverting the revert.
 *
 * Only available while the undo is still your most recent change. Anything done afterwards
 * clears it, the way a new edit clears an editor's redo stack — re-applying a change on top
 * of later work would produce a state nobody asked for.
 */
export const redoChangeMutation = (options?: Partial<Options<RedoChangeData>>): UseMutationOptions<RedoChangeResponse, RedoChangeError, Options<RedoChangeData>> => {
    const mutationOptions: UseMutationOptions<RedoChangeResponse, RedoChangeError, Options<RedoChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await redoChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const nearbyPlacesQueryKey = (options: Options<NearbyPlacesData>) => createQueryKey('nearbyPlaces', options);

/**
 * Venues around a point
 *
 * Names the shop someone is standing in, so the first visit does not need typing.
 *
 * Proxied rather than called from the browser, so the API key stays on the server. Returns
 * an empty list rather than an error when the lookup fails — a places outage should not
 * stop anyone recording an expense.
 */
export const nearbyPlacesOptions = (options: Options<NearbyPlacesData>) => queryOptions<NearbyPlacesResponse, NearbyPlacesError, NearbyPlacesResponse, ReturnType<typeof nearbyPlacesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await nearbyPlaces({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: nearbyPlacesQueryKey(options)
});

export const searchPlacesQueryKey = (options: Options<SearchPlacesData>) => createQueryKey('searchPlaces', options);

/**
 * Find a venue by name
 *
 * Naming a place you are not standing in.
 *
 * Nearby covers the common case — the shop you are in right now — but not recording
 * yesterday's lunch, or anywhere you have already left. Coordinates bias the ranking when
 * they are known and are simply omitted when they are not.
 */
export const searchPlacesOptions = (options: Options<SearchPlacesData>) => queryOptions<SearchPlacesResponse, SearchPlacesError, SearchPlacesResponse, ReturnType<typeof searchPlacesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchPlaces({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPlacesQueryKey(options)
});

export const suggestEntryQueryKey = (options: Options<SuggestEntryData>) => createQueryKey('suggestEntry', options);

/**
 * A guessed entry, with its reasoning
 *
 * What this person probably about to record, drawn only from this budget's own history.
 *
 * Every field the caller already knows narrows the pool the rest is drawn from, so filling
 * in the payee improves the amount and the split rather than being ignored.
 */
export const suggestEntryOptions = (options: Options<SuggestEntryData>) => queryOptions<SuggestEntryResponse, SuggestEntryError, SuggestEntryResponse, ReturnType<typeof suggestEntryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suggestEntry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suggestEntryQueryKey(options)
});
